var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useState } from "react";
import { Field, Input, SubmitButton } from "../../components/components.js";
import { useLogin } from "../../core/auth.js";
import { filterChinese } from "../../core/password.js";
import "./index.scss";
import { GoogleIcon } from "../../components/icon.js";
import { useGoogleLogin } from "../../hooks/useGoogleLogin";
import { buildProfileCompleteUrl } from "../../utils.js";
import { resolveLoginError } from "./error.js";
export const LoginForm = ({ config, locale, options, returnUrl, setAction, showToast, t, onClose }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [remember, setRemember] = useState(false);
    const emailFieldRef = useRef(null);
    const passwordFieldRef = useRef(null);
    const submittable = Boolean(email.trim() && password.trim());
    const [loading, loginApi] = useLogin();
    const currentLocale = locale;
    const PROFILE_COMPLETE_URL = buildProfileCompleteUrl(config.userCenterUrl, currentLocale, returnUrl);
    const getForgotUrl = () => {
        const url = new URL(`/${locale}/forgot`, config.userCenterUrl);
        url.searchParams.set("url", returnUrl);
        return url.href;
    };
    // 使用 Google 登录 hook
    const { googleLoginRef, GoogleScript } = useGoogleLogin({
        onSuccess: (msg) => {
            var _a;
            onClose === null || onClose === void 0 ? void 0 : onClose("success");
            (_a = options.onLoginSuccess) === null || _a === void 0 ? void 0 : _a.call(options, {
                msg,
            });
        },
        locale: currentLocale,
        profileCompleteUrl: PROFILE_COMPLETE_URL,
        clientId: config.googleClientId,
        config,
    });
    const submit = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        yield loginApi({
            config,
            values: { email, password, remember, locale, returnUrl, source: (_a = config.source) !== null && _a !== void 0 ? _a : "" },
            profileCompleteUrl: PROFILE_COMPLETE_URL,
            onSuccess: (result) => {
                var _a;
                (_a = options.onLoginSuccess) === null || _a === void 0 ? void 0 : _a.call(options, result);
                onClose("success");
            },
            onError: (result) => {
                var _a;
                (_a = options.onError) === null || _a === void 0 ? void 0 : _a.call(options, {
                    code: result.code,
                    message: result.msg || t("login.signIn_toast"),
                    cause: result,
                });
                const error = resolveLoginError(result, t("login.signIn_toast"));
                if (error.kind === "warning") {
                    // 弱密码报错
                    showToast({
                        type: "warning",
                        content: (_jsx("div", { children: t.rich("login.simplePasswordMessage", {
                                link: (chunks) => (_jsx("a", { style: { textDecoration: "underline" }, href: getForgotUrl(), children: chunks })),
                            }) })),
                    });
                    return;
                }
                if (error.kind === "locked") {
                    showToast({
                        type: "error",
                        content: t.rich("login.signIn_locked_toast", {
                            link: (chunks) => (_jsx("a", { style: { textDecoration: "underline" }, href: getForgotUrl(), children: chunks })),
                        }),
                    });
                    return;
                }
                if (error.kind === "remaining") {
                    showToast({
                        type: "error",
                        content: t("login.signIn_toast_with_tries_left", { count: error.count }),
                    });
                    return;
                }
                showToast({
                    type: "error",
                    content: error.content,
                });
            },
        });
    });
    return (_jsxs(_Fragment, { children: [_jsx("h2", { className: "modalTitle modal", children: t("login.title") }), _jsx(Field, { ref: emailFieldRef, label: t("login.emailAddress"), name: "email", rules: [{ required: true, message: t("login.requireEmail") }], children: _jsx(Input, { placeholder: t("login.emailAddress"), value: email, autoFocus: true, onChange: (value) => setEmail(value.trim()) }) }), _jsx(Field, { ref: passwordFieldRef, label: t("login.password"), name: "password", rules: [{ required: true, message: t("login.requirePassword") }], className: "smm-auth-form-bottom", extra: _jsxs("button", { className: "smm-auth-link", type: "button", onClick: () => setAction("forgot"), children: [t("login.forgot"), "?"] }), children: _jsx(Input, { placeholder: t("login.password"), type: "password", value: password, transformValue: filterChinese, onChange: setPassword }) }), _jsxs("label", { className: "smm-auth-row", children: [_jsx("input", { type: "checkbox", "data-smm-auth-tab-stop": "true", checked: remember, onChange: (event) => setRemember(event.target.checked) }), t("login.remember")] }), _jsx(SubmitButton, { disabled: !submittable, loading: loading, onClick: submit, children: t("login.signIn") }), _jsxs("div", { className: "smm-auth-bottom", children: [t("login.noAccount"), _jsx("button", { className: "smm-auth-link smm-auth-sign-up", type: "button", onClick: () => setAction("register"), children: t("login.signUp") })] }), _jsx("div", { className: "smm-auth-divider", children: t("login.or") }), _jsxs("div", { ref: googleLoginRef, className: "smm-auth-google", children: [_jsx("span", { className: "smm-auth-google-icon", children: _jsx(GoogleIcon, {}) }), _jsx("span", { className: "text", children: t("login.continue") })] }), _jsx(GoogleScript, {})] }));
};
//# sourceMappingURL=index.js.map